/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `lt` - Less than
 * * `lte` - Less than or equal
 * * `gt` - Greater than
 * * `gte` - Greater than or equal
 * * `eq` - Equal
 * * `neq` - Not equal
 * * `between` - Between
 * @export
 */
export const OperatorEnum = {
    Lt: 'lt',
    Lte: 'lte',
    Gt: 'gt',
    Gte: 'gte',
    Eq: 'eq',
    Neq: 'neq',
    Between: 'between'
} as const;
export type OperatorEnum = typeof OperatorEnum[keyof typeof OperatorEnum];


export function instanceOfOperatorEnum(value: any): boolean {
    for (const key in OperatorEnum) {
        if (Object.prototype.hasOwnProperty.call(OperatorEnum, key)) {
            if (OperatorEnum[key as keyof typeof OperatorEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OperatorEnumFromJSON(json: any): OperatorEnum {
    return OperatorEnumFromJSONTyped(json, false);
}

export function OperatorEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorEnum {
    return json as OperatorEnum;
}

export function OperatorEnumToJSON(value?: OperatorEnum | null): any {
    return value as any;
}

export function OperatorEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): OperatorEnum {
    return value as OperatorEnum;
}

